import React, { createContext, useState, useEffect, ReactNode } from 'react'
import { lightTheme, darkTheme, Theme } from '../config/themes'

interface ThemeContextProps {
	theme: Theme
	toggleTheme: () => void
}

const defaultContext: ThemeContextProps = {
	theme: darkTheme,
	toggleTheme: () => { }
}

export const ThemeContext = createContext<ThemeContextProps>(defaultContext)

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
	const [theme, setTheme] = useState<Theme>(darkTheme)

	useEffect(() => {
		const loadTheme = () => {
			const storedTheme = localStorage.getItem('theme')
			console.log(`ThemeProvider storedTheme : ${storedTheme}`)
			if (storedTheme) {
				setTheme(storedTheme === 'dark' ? darkTheme : lightTheme)

				let color = JSON.stringify({ color: "#000000" });
				if (storedTheme === 'dark') {
					color = JSON.stringify({ color: "#000000" });
				} else {
					color = JSON.stringify({ color: "#FFFFFF" });
				}
				
				window.TelegramWebviewProxy.postEvent('web_app_set_header_color', color); // 텔레그램 헤더
				window.TelegramWebviewProxy.postEvent('web_app_set_background_color', color);
				window.TelegramWebviewProxy.postEvent('web_app_set_bottom_bar_color', color); // 휴대폰 하단 메뉴바
			} else {
				const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
				console.log(`ThemeProvider prefersLight : ${prefersDark}`)

				// let color = JSON.stringify({ color: "#000000" });
				// if (prefersLight) {
				// 	setTheme(lightTheme)
				// 	color = JSON.stringify({ color: "#FFFFFF" });
				// } else {
				// 	setTheme(darkTheme)
				// 	color = JSON.stringify({ color: "#000000" });
				// }

				// setTheme(prefersDark ? darkTheme : lightTheme)
				// TEST 임시 dark 모드 고정
				setTheme(darkTheme)

				// 기본값 dark 로 저장
				localStorage.setItem('theme', 'dark')

				// 텔레그램 색상 변경
				const color = JSON.stringify({ color: "#000000" });
				window.TelegramWebviewProxy.postEvent('web_app_set_header_color', color); // 텔레그램 헤더
				window.TelegramWebviewProxy.postEvent('web_app_set_background_color', color);
				window.TelegramWebviewProxy.postEvent('web_app_set_bottom_bar_color', color); // 휴대폰 하단 메뉴바
			}
		}
		loadTheme()
	}, [])

	const toggleTheme = async () => {
		const newTheme = theme === lightTheme ? darkTheme : lightTheme
		await localStorage.setItem('theme', newTheme === darkTheme ? 'dark' : 'light')

		let color = JSON.stringify({ color: "#000000" });
		if (newTheme === darkTheme) {
			setTheme(newTheme)
			color = JSON.stringify({ color: "#000000" });
		} else {
			setTheme(newTheme)
			color = JSON.stringify({ color: "#FFFFFF" });
		}

		// 텔레그램 색상 변경
		// const color = JSON.stringify({ color: "#000000" });
		window.TelegramWebviewProxy.postEvent('web_app_set_header_color', color); // 텔레그램 헤더
		window.TelegramWebviewProxy.postEvent('web_app_set_background_color', color);
		window.TelegramWebviewProxy.postEvent('web_app_set_bottom_bar_color', color); // 휴대폰 하단 메뉴바
	}

	return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>
}
